import {AbstractControl, ValidatorFn} from "@angular/forms";

export class ArrayValidators {

  public static min(min: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (!Array.isArray(control.value) || control.value.length >= min) return null;

      return {arrayMin: true};
    };
  }

}
